<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bkht">
<h1 class="bkht"><a class="page" id="pi"></a>Pain, Pleasure, and the Greater Good</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-gere-0002.vue?7630db8d